module.exports = __webpack_public_path__ + "img/EEK.37e28add.svg";